export const DISPLAY_WALL_SUCCESS_SAVE = `Display wall has been successfully saved !`
export const SUCCESS_TEXT = `Success !`
export const MEDIA_SUCCESS_SAVE = `Media has been successfully saved !`
export const URL_SUCCESS_SAVE = `Url has been successfully saved !`
export const SHORT_CODE_SUCCESS_SAVE = `Short Code has been successfully saved !`
export const DISPLAY_APPS_SUCCESS_SAVE = `Your Content has been successfully saved  !`